import React from 'react';
import { useAppDispatch, useAppSelector } from '@/redux/Store';
import { setActiveRoom } from '@/redux/slices/chatSlice';
import { fetchRoomMessages } from '@/redux/thunks/chatThunks';
import './RoomList.scss';

const RoomList: React.FC = () => {
  const dispatch = useAppDispatch();
  const rooms = useAppSelector((s) => s.chat.rooms);
  const activeRoomId = useAppSelector((s) => s.chat.activeRoomId);
  const loading = useAppSelector((s) => s.chat.roomsLoading);

  const handleSelect = (roomId: string) => {
    if (roomId === activeRoomId) return;
    dispatch(setActiveRoom(roomId));
    dispatch(fetchRoomMessages({ roomId }));
  };

  if (loading) {
    return (
      <aside className="room-list room-list--loading">
        {[1, 2, 3].map((i) => (
          <div key={i} className="room-list__skeleton" />
        ))}
      </aside>
    );
  }

  return (
    <aside className="room-list">
      <h3 className="room-list__heading">Rooms</h3>
      <ul className="room-list__items">
        {rooms.map((room) => (
          <li key={room.id}>
            <button
              className={`room-list__item ${room.id === activeRoomId ? 'active' : ''}`}
              onClick={() => handleSelect(room.id)}
            >
              <span className="room-list__hash">#</span>
              <span className="room-list__name">{room.name}</span>
            </button>
          </li>
        ))}
      </ul>
    </aside>
  );
};

export default RoomList;
